import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getHedge, updateHedgeDetails, deleteHedge, hedgeUpdateHedgeEscrow } from "store/state/hedge";
import { getHedgeEscrowsByHedgeId, hedgeEscrowUpdate } from "store/state/hedgeEscrow";
import { getDealName } from 'store/state/deal';
import HedgeEscrowLedgerTable from "./HedgeEscrowLedgerTable";
import HedgeEscrowLedgerHeader from "./HedgeEscrowLedgerHeader";
import styled from "styled-components";
import { withRouter } from "react-router";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import EscrowCapModal from 'components/HedgeDetailPage/EscrowCapModal';

const PagePadding = styled.div`
  padding: 16px;
  max-width:1400px;
  margin: 0 20px 250px 20px;
`;

const DIALOG_OPTIONS = {
  CONFIRM: 'CONFIRM'
  , EDIT_ASSUMPTIONS: 'EDIT_ASSUMPTIONS'
};

class HedgeEscrowLedger extends Component {
  state = {
    hedge: null
    , hedgeEscrows: []
    , breadCrumb: {}
    , activeDialog: null
    , canRecalculate: false
    , isLoading: true
  };

  componentWillMount() {
    const { hedgeId, dealId } = this.props;
    this.props.getHedge({ hedgeId, dealId });
    this.props.getHedgeEscrowsByHedgeId({ hedgeId });
    this.props.getDealName({ dealId, subKey: dealId });
  }

  componentDidUpdate(prevProps) {
    const { hedge, dealId, dealName, hedgeEscrows } = this.props;

    if (this.props !== prevProps) {
      const tempState = {
        ...this.state
        , isLoading: this.props.isLoading
      };

      if (dealId && dealName) {
        tempState.breadCrumb.deal = {
          id: dealId
          , display: dealName.name
        }
      }

      if (hedge && hedge.id) {
        tempState.breadCrumb.hedge = {
          id: hedge.id
          , display: hedge.hedgeProvider.name
        }
      }

      if (hedgeEscrows.length) {
        tempState.hedgeEscrows = hedgeEscrows.sort((a, b) => b.period - a.period).reverse();
      }

      this.setState(tempState);
    }
  }

  onDelete = () => {
    const { hedgeId } = this.props;
    this.setState({ activeDialog: null });
    const callback = () => this.props.history.goBack();
    this.props.deleteHedge({ hedgeId, callback });
  }

  //handleEditAssumptions
  onEscrowCapModalClose = (isOpen = false, values) => {
    this.setState({ activeDialog: null });

    if (!!values) {
      const hedge = { ...this.state.hedge, ...values, id: this.props.hedgeId };
      this.setState({ hedgeEscrows: [] });

      const callback = () => this.props.getHedgeEscrowsByHedgeId({ hedgeId: hedge.id });
      hedge.replacingHedgeId = this.props.replacingHedgeId;
      this.props.hedgeUpdateHedgeEscrow({ hedge, callback });
    }
  }

  //handleRecalculate
  onSave = (hedgeEscrow) => {
    hedgeEscrow.isUserOverride = true;
    const { hedgeId } = this.props;
    const callback = () => this.props.getHedgeEscrowsByHedgeId({ hedgeId });
    this.props.hedgeEscrowUpdate({ hedgeEscrow, callback });
  }

  render() {
    const {hedge} = this.props;
    const { breadCrumb, hedgeEscrows } = this.state;

    return (
      <>
        <PagePadding>
          <HedgeEscrowLedgerHeader
            breadCrumb={breadCrumb}
            onRemoveEscrowCalculation={() => this.setState({ activeDialog: DIALOG_OPTIONS.CONFIRM })}
            onRecalculate={this.handleRecalculate}
            canRecalculate={this.state.canRecalculate}
            onEditAssumptions={() => this.setState({ activeDialog: DIALOG_OPTIONS.EDIT_ASSUMPTIONS })}
          />
          <HedgeEscrowLedgerTable
            onSave={this.onSave}
            hedgeEscrows={hedgeEscrows}
            hedge={hedge}
          />
        </PagePadding>

        <SimpleConfirmDialog
          modalOpen={this.state.activeDialog === DIALOG_OPTIONS.CONFIRM}
          title="Confirm Deletion"
          message={`Are you sure? This will remove the escrow calculation, which cannot be undone.`}
          yesText="Yes, Delete"
          noText="No"
          handleNo={() => this.setState({ activeDialog: null })}
          handleYes={this.onDelete}
        />

        {
          this.state.activeDialog === DIALOG_OPTIONS.EDIT_ASSUMPTIONS &&
          <EscrowCapModal
            isOpen={this.state.activeDialog === DIALOG_OPTIONS.EDIT_ASSUMPTIONS}
            handleClose={this.onEscrowCapModalClose}
          />
        }
      </>
    );
  }
}

const mapStateToProps = (
  { hedge, deal, hedgeEscrow }
  , { match: { params: { dealId, hedgeId, replacingHedgeId } } }
) => ({
  hedge: hedge && hedge.hedgeDetail && hedge.hedgeDetail.details
  , dealId
  , hedgeId
  , hedgeEscrows: hedgeEscrow.hedgeEscrows
  , dealName: deal.dealNames[dealId]
  , isLoading: hedgeEscrow.isLoading
});

export default compose(
  withRouter
  , connect(mapStateToProps
    , {
      getHedge
      , updateHedgeDetails
      , getDealName
      , deleteHedge
      , hedgeUpdateHedgeEscrow
      , hedgeEscrowUpdate
      , getHedgeEscrowsByHedgeId
    })
)(HedgeEscrowLedger);